import React from 'react';
import { Phone, Mail } from 'lucide-react';

export default function FloatingWidgets() {
  return (
    <>
      {/* Phone Widget */}
      <a
        href="tel:+4576991020"
        className="fixed right-0 top-[calc(50%-35px)] -translate-y-1/2 z-50 group flex items-center transition-all duration-300 ease-in-out w-14 hover:w-[220px] overflow-hidden shadow-xl rounded-l-md bg-white"
      >
        {/* Icon container (on the left, blue background) */}
        <div className="w-14 h-14 flex items-center justify-center bg-[#0073A5] text-white shrink-0">
          <i className="fad fa-phone-rotary text-xl" style={{ fontFamily: '"Font Awesome 6 Duotone", "Font Awesome 5 Pro"', '--fa-primary-color': '#ffffff', '--fa-secondary-color': '#80c9e8', '--fa-secondary-opacity': '1.0' }}></i>
        </div>
        {/* Info container (on the right, white background) */}
        <div className="px-5 py-4 whitespace-nowrap bg-white text-[#00364a] font-bold text-base leading-none shrink-0">
          (+45) 76 99 10 20
        </div>
      </a>

      {/* Mail Widget */}
      <a
        href="mailto:info@dan-team.com"
        className="fixed right-0 top-[calc(50%+35px)] -translate-y-1/2 z-50 group flex items-center transition-all duration-300 ease-in-out w-14 hover:w-[240px] overflow-hidden shadow-xl rounded-l-md bg-white"
      >
        {/* Icon container (on the left, blue background) */}
        <div className="w-14 h-14 flex items-center justify-center bg-[#0073A5] text-white shrink-0">
          <i className="fad fa-mailbox fa-swap-opacity text-xl" style={{ fontFamily: '"Font Awesome 6 Duotone", "Font Awesome 5 Pro"', '--fa-primary-color': '#ffffff', '--fa-secondary-color': '#80c9e8', '--fa-secondary-opacity': '1.0' }}></i>
        </div>
        {/* Info container (on the right, white background) */}
        <div className="px-5 py-4 whitespace-nowrap bg-white text-[#00364a] font-bold text-base leading-none shrink-0">
          info@dan-team.com
        </div>
      </a>
    </>
  );
}
